import { ServiceDataFields } from './service-data-fields.enum';

export const cancerscreenFieldSet = [
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.PatientGender,
  ServiceDataFields.DiseaseHistory,
  ServiceDataFields.FamilyCancerHistory,
  ServiceDataFields.KnownFamilyMutations,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.PatientGender,
];
